import React from 'react';
import ProjectTopComponent from '../Components/Projekte/ProjectTopComponent';
import ProjectPlanComponent from '../Components/Projekte/ProjectPlanComponent';
import ProjectBottonComponent from '../Components/Projekte/ProjectBottonComponent';

const NewTextTemplatePage = (props) => {

    const [projectSetup, setProjectSetup] = React.useState({

        "organisationID": sessionStorage.getItem("org"),
        "projectID": "",
        "projectName": "",
        "auftraggebber": "",
        "customerIdentificator": "",
        "projectStatus": "inactive",
        "address": {},
        "defaultZone": "",
        "bookingRadius": "",
        "planData": []

    });

    const [addPlanDataProjectSetup, setAddPlanDataProjectSetup] = React.useState([]);

    const [imagePaths, setImagePaths] = React.useState([]);

    const [auftraggeberList, setAuftraggeberList] = React.useState([{
        firstName: "",
        lastName: "",
        status: false,
        input_rank: null,
        entscheidungsbefugnis: false,
        email: ""
    }]);

    React.useEffect(() => {

        if (props.location.state) {

            let agData = props.location.state.agData;
            setAuftraggeberList(agData.data)

            let editProjectSetup = props.location.state.projectInformation.project;
            setProjectSetup(editProjectSetup);

            let planDataInfo = props.location.state.projectInformation.plan.planData;

            for (let i = 0; i < planDataInfo.length; i++) {

                const objectPath =planDataInfo[i].objectPath
                planDataInfo[i].url = props.location.state.planLinks[objectPath].url;
                //planDataInfo[i].url = props.location.state.planLinks[i].url;

            }

            setAddPlanDataProjectSetup(addPlanDataProjectSetup);
            setProjectSetup((prevState => ({

                ...prevState,
                planData: planDataInfo,

            })));

        }
    }, [])


    return (
        <div className="handwai-dark"
             style={{
                 height: '94vh',
                 width: '100vw',
                 overflowY: 'scroll',
                 overflowX: 'hidden',
             }}
        >

            <br/>

            <ProjectTopComponent
                projectSetup={projectSetup}
                setProjectSetup={setProjectSetup}
            />

            <br/> <br/>

            <ProjectPlanComponent
                projectSetup={projectSetup}
                setProjectSetup={setProjectSetup}
                imagePaths={imagePaths}
                setImagePaths={setImagePaths}
                setAuftraggeberList={setAuftraggeberList}
                auftraggeberList={auftraggeberList}


            />

            <br/> <br/>

            <ProjectBottonComponent
                projectSetup={projectSetup}
                imagePaths={imagePaths}
                setProjectSetup={setProjectSetup}
                auftraggeberList={auftraggeberList}
            />

            <br/> <br/>
        </div>
    );
}

export default NewTextTemplatePage;